export function handlebtn(btn, changeInfo, setbtns) {
    changeInfo(<></>);
    setbtns((a) => ({
      ...a,
      activate: {
        ...btn,
      },
    }));
  }